import { Card, Icon, Tag, Text } from "@ttc3k/trekker";
import { EditPencil, NavArrowRight } from "iconoir-react";
import { Flex } from "styled-system/jsx";
import { FilterKey, FilterOptionItem } from "./constants";
import { useTranslation } from "react-i18next";
import { TagByIdsQuery, TagGroupByIdsQuery } from "gql/generated";
import { ListFilters } from "apps/customLists/components/filterScreens";
import { useMemo } from "react";
import { ClickableCardSurface } from "shared/components/atoms";
import { getFilterTagData } from "shared/utils";

type ListFilterCardProps = {
  filter: FilterOptionItem;
  onScreenChange: (key: FilterKey) => void;
  tags: TagByIdsQuery["tagByIds"];
  tagGroups: TagGroupByIdsQuery["tagGroupByIds"];
  appliedFilters: ListFilters;
};

export const ListFilterCard = ({
  filter,
  onScreenChange,
  tags,
  tagGroups,
  appliedFilters,
}: ListFilterCardProps) => {
  const { t } = useTranslation();

  const filterTagData = useMemo(
    () => getFilterTagData(t, filter, appliedFilters, tags, tagGroups),
    [appliedFilters, filter, t, tagGroups, tags],
  );

  const isEditing = filterTagData.length > 0;

  return (
    <button onClick={() => onScreenChange(filter.key)}>
      <ClickableCardSurface className={"group"}>
        <Card.Body p={"250"}>
          <Card.BodyContent alignItems={"center"}>
            <Flex gap={"100"} alignItems={"center"}>
              <Icon Element={filter.icon} />
              <Text visual={"smallSemiBold"} color={"text.dark"}>
                {t(`core:FILTER.${filter.key}.TITLE`)}
              </Text>
            </Flex>
            <Icon
              Element={isEditing ? EditPencil : NavArrowRight}
              transitionDuration={"normal"}
              transitionProperty={"color"}
              transitionTimingFunction={"default"}
              color={{
                base: "icon.mid",
                _groupHover: {
                  base: "icon.light",
                },
              }}
            />
          </Card.BodyContent>
          {isEditing && (
            <Flex gap={"100"} flexWrap={"wrap"}>
              {filterTagData.map((name) => (
                <Tag key={name} visual={"success"} mode={"light"}>
                  {name}
                </Tag>
              ))}
            </Flex>
          )}
        </Card.Body>
      </ClickableCardSurface>
    </button>
  );
};
